import React, { useState } from "react";
import { Ticket, X, Loader2 } from "lucide-react";
import api from "@/lib/api";

export const couponDiscount = (coupon, unitPaise, n) => {
  if (!coupon || (coupon.min_delegates && n < coupon.min_delegates)) return 0;
  const total = unitPaise * n;
  const d = coupon.discount_type === "amount"
    ? Math.min(Math.round(coupon.value * 100), unitPaise) * n
    : Math.round((total * coupon.value) / 100);
  return Math.min(d, total);
};

export const CouponBox = ({ slug, count, coupon, setCoupon }) => {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const apply = async () => {
    if (!code.trim()) return;
    setBusy(true); setErr("");
    try {
      const { data } = await api.post(`/public/forms/${slug}/coupon`, { code, delegate_count: count });
      setCoupon(data);
    } catch (e) { setErr(e?.response?.data?.detail || "Invalid coupon"); }
    finally { setBusy(false); }
  };
  if (coupon) {
    const short = coupon.min_delegates && count < coupon.min_delegates;
    return (
      <div className={`rounded-2xl border p-3 flex items-center gap-2 text-sm ${short ? "border-amber-300 bg-amber-50" : "border-emerald-200 bg-emerald-50"}`} data-testid="pf-coupon-applied">
        <Ticket className={`w-4 h-4 shrink-0 ${short ? "text-amber-600" : "text-emerald-600"}`} />
        <div className="flex-1">
          <b className="font-mono">{coupon.code}</b> applied
          {short && <div className="text-xs text-amber-800">Needs at least {coupon.min_delegates} delegates. Add more to get the discount.</div>}
        </div>
        <button type="button" onClick={() => { setCoupon(null); setCode(""); }} className="p-1 rounded-full hover:bg-white" aria-label="Remove coupon" data-testid="pf-coupon-remove"><X className="w-4 h-4" /></button>
      </div>
    );
  }
  return (
    <div data-testid="pf-coupon-box">
      <div className="flex gap-2">
        <input className={`input-pill flex-1 ${code ? "uppercase" : ""}`} placeholder="Have a coupon code?" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); apply(); } }} data-testid="pf-coupon-input" />
        <button type="button" onClick={apply} disabled={busy || !code.trim()} className="btn-ghost border border-slate-200 disabled:opacity-50" data-testid="pf-coupon-apply">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Apply"}
        </button>
      </div>
      {err && <div className="text-xs text-rose-600 mt-1" data-testid="pf-coupon-error">{err}</div>}
    </div>
  );
};
